/* eslint-disable-next-line no-undef */
class QuantityInput extends HTMLElement {
  constructor () {
    super()
    const isProductPage = document.body.classList.contains('product')
    this.min = parseInt(this.getAttribute('data-min'))
    this.max = parseInt(this.getAttribute('data-max'))
    this.step = parseInt(this.getAttribute('step'))
    this.value = parseInt(this.getAttribute('value'))
    this.input = this.querySelector('.quantity__input')
    this.buttons = this.querySelectorAll('button')
    this.changeEvent = new Event('change', { bubbles: true })
    this.isAvailable = document.querySelector('variant-selects[id*="__main"] > script') != null ? JSON.parse(document.querySelector('variant-selects[id*="__main"] > script').textContent).available : true

    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this))
    }
    if (this.buttons) {
      this.buttons.forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      )
    }

    if (!isProductPage) {
      return
    }

    this.select = document.createElement('select')
    this.select.classList.add('quantity__select')
    this.select.setAttribute('data-value', this.value)

    for (let i = this.min; i <= this.max; i += this.step) {
      const option = document.createElement('option')
      option.value = i
      option.text = i
      if (i === this.min) { option.setAttribute('selected', 'selected') }
      this.select.appendChild(option)
    }

    this.select.value = this.value

    // Add event listener for select change
    this.select.addEventListener('change', this.onSelectChange.bind(this))

    // Append both input and select elements to the custom element
    this.appendChild(this.select)

    // Listen for the variantChanged event and update the isAvailable value
    // eslint-disable-next-line no-undef
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
      this.isAvailable = event.data.isAvailable
    })
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }

  onInputChange (event) {
    this.validateQtyRules()
  }

  validateQtyRules () {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      /* eslint-disable-next-line no-unused-vars */
      const isCartPage = document.body.classList.contains('cart')
      buttonMinus.classList.toggle('disabled', value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }

  onSelectChange (event) {
    this.value = parseInt(event.target.value)
    this.input.value = this.value

    this.select.setAttribute('data-value', this.value)
    const options = this.select.querySelectorAll('option')
    options.forEach(option => {
      option.removeAttribute('selected')
    })

    const selectedOption = this.select.querySelector(`option[value="${this.value}"]`)
    if (selectedOption) {
      selectedOption.setAttribute('selected', 'selected')
    }
    const stickyQuantityInput = document.querySelector('.quantity__input-sticky')
    if (stickyQuantityInput) {
      stickyQuantityInput.value = this.value
      stickyQuantityInput.setAttribute('value', this.value)
    }

    const stickyQuantityInputMobile = document.querySelector('.quantity__input-sticky-mobile')
    if (stickyQuantityInputMobile) {
      stickyQuantityInputMobile.value = this.value
      stickyQuantityInputMobile.setAttribute('value', this.value)
    }
    updatePrices(null, null, this.isAvailable)
    this.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
/* eslint-disable-next-line no-undef */
customElements.define('quantity-input', QuantityInput)

/* eslint-disable-next-line no-unused-vars */
function updatePrices (currentPriceValue, currentComparePriceValue, isAvailable) {
  const currentQuantity = document.querySelector('.main-product .product__info-container .quantity__select').getAttribute('data-value')

  if (!currentPriceValue) {
    currentPriceValue = document.querySelector('.product__info-container .price-item.price-item--sale').getAttribute('data-price')
  }
  if (!currentComparePriceValue) {
    currentComparePriceValue = document.querySelector('.product__info-container .price-item.price-item--regular').getAttribute('data-price-regular')
  }

  if (currentPriceValue) {
    const currentPrice = document.querySelector('.product__info-container .price-upsells .price-item--sale')
    const currentStickyPrice = document.querySelector('.sticky-price .price-item--sale')
    const currentSinglePrice = document.querySelector('[id*="price-template"] .price__sale .price-item--sale')
    const newPrice = (parseInt(currentPriceValue) * parseInt(currentQuantity)).toString()
    const newPriceLength = newPrice.length - 2
    const newPriceCents = newPrice.slice(-2)
    const newPriceDollar = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newPrice.slice(0, newPriceLength))
    if (currentPrice) {
      currentPrice.innerHTML = `${newPriceDollar}<span class="decimals">${newPriceCents}</span>`
    }
    if (currentStickyPrice) {
      currentStickyPrice.innerHTML = `${newPriceDollar}<span class="decimals">${newPriceCents}</span>`
    }
    if (currentSinglePrice) {
      currentSinglePrice.setAttribute('data-price', currentPriceValue)
      const currentSinglePriceLength = currentPriceValue.toString().length - 2
      const currentSinglePriceCents = currentPriceValue.toString().slice(-2)
      const newSinglePrice = currentPriceValue.toString()
      const newSinglePriceDollar = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newSinglePrice.slice(0, currentSinglePriceLength)).replace('$', '$ ')
      currentSinglePrice.innerHTML = `${newSinglePriceDollar}<span class="decimals">${currentSinglePriceCents}</span>`
    }
  }

  if (currentComparePriceValue) {
    const comparePrice = document.querySelector('.product__info-container .price-upsells .price-item--regular')
    const compareStickyPrice = document.querySelector('.sticky-price .price-item--regular')
    const currentCompareSinglePrice = document.querySelector('[id*="price-template"] .price__sale .price-item--regular')
    const newComparePrice = (currentComparePriceValue * parseInt(currentQuantity)).toString()
    const newComparePriceLength = newComparePrice.length - 2
    const newComparePriceCents = newComparePrice.slice(-2)
    const newComparePriceDollar = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newComparePrice.slice(0, newComparePriceLength))
    if (comparePrice) {
      comparePrice.innerHTML = `${newComparePriceDollar}<span class="decimals">${newComparePriceCents}</span>`
    }
    if (compareStickyPrice) {
      compareStickyPrice.innerHTML = `${newComparePriceDollar}<span class="decimals">${newComparePriceCents}</span>`
    }
    if (currentCompareSinglePrice) {
      currentCompareSinglePrice.setAttribute('data-price-regular', currentComparePriceValue)
      const currentCompareSinglePriceLength = currentComparePriceValue.toString().length - 2
      const currentCompareSinglePriceCents = currentComparePriceValue.toString().slice(-2)
      const newCompareSinglePrice = currentComparePriceValue.toString()
      const newCompareSinglePriceDollar = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newCompareSinglePrice.slice(0, currentCompareSinglePriceLength))
      currentCompareSinglePrice.innerHTML = `${newCompareSinglePriceDollar}<span class="decimals">${currentCompareSinglePriceCents}</span>`
    }
  }

  const addToCartQty = document.querySelectorAll('.large-button-add-to-cart .button')
  let togglesActive = 0

  // eslint-disable-next-line no-undef
  if (sessionStorage.getItem('rebuyLoaded') && sessionStorage.getItem('rebuyLoaded') === 'true') {
    togglesActive = document.querySelectorAll('.add-to-cart-toggle:checked').length
  }

  document.querySelector('.product__info-container .quantity__input').setAttribute('value', currentQuantity)

  addToCartQty.forEach(function (element) {
    if (isAvailable === true) {
      if (window.innerWidth > 767) {
        if (currentQuantity) {
          if (parseInt(currentQuantity) > 1) {
            (togglesActive < 1) ? element.innerHTML = `<span>ADD ${parseInt(currentQuantity)} ITEMS TO CART` : element.innerHTML = `ADD ${togglesActive + parseInt(currentQuantity)} ITEMS TO CART</span>`
          } else {
            (togglesActive < 1) ? element.innerHTML = `<span>ADD ${parseInt(currentQuantity)} ITEM TO CART` : element.innerHTML = `ADD ${togglesActive + parseInt(currentQuantity)} ITEMS TO CART</span>`
          }
        } else {
          (togglesActive < 1) ? element.innerHTML = 'ADD 1 ITEM TO CART' : element.innerHTML = `ADD ${togglesActive + 1} ITEMS TO CART`
        }
      } else {
        element.innerHTML = 'ADD TO CART'
      }
    } else {
      element.innerHTML = '<span>Sold out</span>'
    }
  })
}
